module.exports = __webpack_public_path__ + "static/media/elicohen.90378df4.jpg";